<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
              <el-form-item label="广告名称:" prop="title">
                <el-input v-model="formInlineTmp.title" placeholder="请输入广告名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="开始时间:" prop="start_date">
                <el-date-picker style="width:193px;"
                  class="time-picker"
                  v-model="formInlineTmp.start_date"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间:" prop="end_date">
                <el-date-picker style="width:193px;"
                  class="time-picker"
                  @change="judgeDate"
                  v-model="formInlineTmp.end_date"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">广告列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="addAdvertiseAction" class="add-btn" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        v-loading="loading"
        :data="tableData"
        class="table">
        <!-- <el-table-column
          label="缩略"
          width="150">
          <template slot-scope="scope">
            <img :src="scope.row.img" class="table-img">
          </template>
        </el-table-column> -->
        <el-table-column
          prop="title"
          label="广告名称">
        </el-table-column>
        <el-table-column
          label="广告位置">
          <template slot-scope="scope">
            <div v-if="scope.row.category_id === 1">会员首页</div>
            <div v-if="scope.row.category_id === 2">积分商城首页</div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          label="开始时间">
          <template slot-scope="scope">
            {{scope.row.start.substring(0, 16)}}
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          label="结束时间">
          <template slot-scope="scope">
            {{scope.row.end.substring(0, 16)}}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          width="120"
          label="状态">
          <template slot-scope="scope">
              <div v-if="scope.row.status === 1" @click="switchChange(scope.row, 0)" class="enable-button">禁用</div>
              <div v-if="scope.row.status === 0" @click="switchChange(scope.row, 1)" class="enable-button">启用</div>
            <!--<el-switch-->
              <!--v-model="scope.row.status"-->
              <!--:active-value="1"-->
              <!--:inactive-value="0"-->
              <!--@click.native="switchChange(scope.row)"-->
              <!--active-text=""-->
              <!--inactive-text="">-->
            <!--</el-switch>-->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
          <template slot-scope="scope">
              <div class="op-link" @click="pushToEditAdvertisePage(scope.row.id)">
                编辑
              </div>
              <div class="op-link" @click="deleteAdviristAction(scope.row.id)">
                删除
              </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getAdvertiseList, deleteAdvertise, changeAdevertiseStatus } from '@/api/customer.js'
export default {
  name: 'importData',
  data () {
    return {
      formInlineTmp: {},
      formInline: {
        start_date: '',
        end_date: '',
        title: ''
      },
      hide: true,
      loading: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      isSwitchClick: 1
    }
  },
  methods: {
    searchData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    judgeDate() {
      if (this.formInline.start_date !== undefined && this.formInline.end_date !== undefined) {
        let test = new RegExp('/-/g')
        let d1 = new Date(this.formInline.start_date.replace(test, '/'))
        let d2 = new Date(this.formInline.end_date.replace(test, '/'))
        if (d1 > d2) {
          _g.toastMsg('error', '开始时间不能大于结束时间!')
          return false
        }
      }
    },
    switchChange(row, status) {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          changeAdevertiseStatus(row.id, status).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getData()
          })
        })
      }
    },
    addAdvertiseAction() {
      router.push('/home/add-advertise')
    },
    pushToEditAdvertisePage(Id) {
      router.push({ path: '/home/edit-advertise', query: { id: Id } })
    },
    deleteAdviristAction(itemId) {
      this.$confirm('确认删除该广告?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAdvertise(itemId).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除广告成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      if (this.formInline.start_date !== undefined && this.formInline.end_date !== undefined) {
        if (this.judgeDate() === false) {
          return
        }
      }
      getAdvertiseList(this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
          this.openLoading()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.enable-button {
    color: #1980FF;
    cursor: pointer;
    font-size: 14px;
}
</style>
